import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";

const http = new HttpService();

// Broadcast whenever the signed-in user's plan changes (free trial claimed,
// purchase completed). Always-mounted chrome — the header's PRO badge and
// "Upgrade" button — fetches the plan in an effect keyed on UserReducer, which
// a plan change does NOT alter, so without an explicit signal the header keeps
// showing the old state until the next navigation happens to remount it.
// Declared here so producers and listeners can never drift on the name.
export const SUBSCRIPTION_CHANGED_EVENT = 'cc:subscription-changed';

export const notifySubscriptionChanged = () => {
  try {
    window.dispatchEvent(new Event(SUBSCRIPTION_CHANGED_EVENT));
  } catch {
    /* non-fatal: the badge just refreshes on the next navigation instead */
  }
};

export class SubscriptionService {
  async getPlanDetails(data: any) {
    const path = BASE_URL + "/get/subscription/plans/detail";
    const response = await http.postRequest(path, data, null);
    return response;
  }

  async getSubscription_Remaining_Days(data: any) {
    const path = BASE_URL + "/get/subscription/days/left";
    const response = await http.postRequest(path, data, null);
    return response;
  }

  async getSubscription_History(data: any) {
    const path = BASE_URL + "/get/subscription/history";
    const response = await http.postRequest(path, data, null);
    return response;
  }

  async getFocCampaignPlanDetail(data: any) {
    const path = BASE_URL + "/get/brand/foc/campaign_plan_details";
    const response = await http.postRequest(path, data, null);
    return response;
  }

  // async getFocRepublishCampaignPlanDetail(data: any) {
  //   const path = BASE_URL + "/get/brand/foc/republish_campaign";
  //   const response = await http.postRequest(path, data, null);
  //   return response;
  // }

  async getSubscriptionInvoice(data: {token: string}) {
    try {
      const path = BASE_URL + `/get/subscription/invoice`;
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Request a Demo :: ${error}`);
    }
  }

  async getCurrentPlan(data: any) {
    const path = BASE_URL + "/get/subscription/current-plan-details";
    const response = await http.postRequest(path, data, null);
    return response;
  }

  // 7-day free trial: current state (eligible / active / already used).
  // The plan-listing API already stamps these flags onto the Trial card, so
  // this is only needed where the listing isn't being fetched anyway.
  async getTrialStatus(data: { influencer_id: number }) {
    const path = BASE_URL + "/subscription/trial/status";
    const response = await http.postRequest(path, data, null);
    return response;
  }

  // 7-day free trial: claim it. No payment, no card — the backend writes a
  // zero-amount subscription row that simply lapses after 7 days.
  async claimTrial(data: { user_id: number; account_id: number; influencer_id: number }) {
    const path = BASE_URL + "/subscription/trial/claim";
    const response = await http.postRequest(path, data, null);
    return response;
  }

  // Validate a special coupon code for the influencer yearly plan (price preview)
  async validateCoupon(data: { coupon_code: string; influencer_id: number }) {
    const path = BASE_URL + "/subscription/coupon/validate";
    const response = await http.postRequest(path, data, null);
    return response;
  }
}
